// !------------- Core React and State Management -------------! 
// !--- REACT ---! 
import React, { useState, useEffect } from 'react';
// Documentation: https://reactjs.org/
// !------------- Material UI Components and Icons -------------! 
// !--- MUI ---! 
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import { QuestionMark as QuestionMarkIcon, Settings as SettingsIcon } from '@mui/icons-material';
// @mui/material and @mui/icons-material - Material UI components and icons for React. Documentation: https://mui.com/
// !------------- Tour -------------! 
// !--- REACTOUR ---! 
import { useTour } from '@reactour/tour'
// Documentation: https://www.npmjs.com/package/@reactour/tour
// !------------- Custom Components and Styles -------------! 
import ToggleColor from '../ToggleColor';

const NavBar = ({ colors, Params }) => {
  const { setIsOpen, isOpen } = useTour();

  const appBarStyle = {
    backgroundColor: colors?.secondary || 'white',
    position: 'absolute'
  };

 const coloring = {
  secondary: colors.accent, 
  accent: colors.main
};


 return (
   <>
     <AppBar style={appBarStyle}>
       <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
         <Grid container justifyContent="right">
            <Tooltip title="Toggle Tutorial" placement="bottom">
              <IconButton onClick={() => setIsOpen(true)} sx={{ marginTop: 0.5 }}
                data-tour="step-tutorial"
              >
                <ToggleColor
                  icon={<QuestionMarkIcon style={{ fontSize: 30 }} />}
                  colors={coloring}
                  isActive={isOpen}
                />
              </IconButton>
            </Tooltip>
         </Grid>
       </Toolbar>
     </AppBar>
   </>
 );
};

export default NavBar;
